import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="refresh"
export default class extends Controller {

  static values = { poll: { type: Number, default: 30_000 } }
  
  connect() {
    this.interval = setInterval(() => {
      if (document.hidden) return
      const frame = this.element.closest("turbo-frame")
      frame && frame.reload()
    }, this.pollValue)
  }

  disconnect() {
    this.interval && clearInterval(this.interval)
  }

}
